"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortType = void 0;
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
var SortType;
(function (SortType) {
    SortType["ASCENDING"] = "asc";
    SortType["DESCENDING"] = "desc";
    SortType["ORIGINAL"] = "original";
})(SortType || (exports.SortType = SortType = {}));
function useTableSortBy(items, config = null) {
    const [sortConfig, setSortConfig] = (0, react_1.useState)(config);
    const sortedItems = (0, react_1.useMemo)(() => {
        const sortableItems = items.slice();
        if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
                if (sortConfig.direction === SortType.ASCENDING) {
                    return ((0, get_1.default)(a, sortConfig.key, 0) - (0, get_1.default)(b, sortConfig.key, 0));
                }
                else if (sortConfig.direction === SortType.DESCENDING) {
                    return ((0, get_1.default)(b, sortConfig.key, 0) - (0, get_1.default)(a, sortConfig.key, 0));
                }
                return 0;
            });
        }
        return sortableItems;
    }, [items, sortConfig]);
    const sortHandler = (0, react_1.useCallback)((event) => {
        const key = event.currentTarget?.id;
        let direction = SortType.ASCENDING;
        if (key && sortConfig && sortConfig.key === key) {
            switch (sortConfig.direction) {
                case SortType.ASCENDING:
                    direction = SortType.DESCENDING;
                    break;
                case SortType.DESCENDING:
                    direction = SortType.ORIGINAL;
                    break;
                default:
                    direction = SortType.ASCENDING;
                    break;
            }
        }
        setSortConfig({ key, direction });
    }, [sortConfig]);
    const isSortedDesc = (0, react_1.useCallback)((columnName) => {
        const defaultContent = { flag: null, content: ' ' };
        if (!sortConfig || sortConfig.key !== columnName) {
            return defaultContent;
        }
        switch (sortConfig.direction) {
            case SortType.DESCENDING:
                return { flag: true, content: ' ▼' };
            case SortType.ASCENDING:
                return { flag: false, content: ' ▲' };
            default:
                return defaultContent;
        }
    }, [sortConfig]);
    return { items: sortedItems, isSortedDesc, onSort: { onClick: sortHandler } };
}
exports.default = useTableSortBy;
